import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ShoppingService } from '../../../core/services/shopping.service';

@Component({
  selector: 'app-instructor-resend-confirmation',
  templateUrl: './instructor-resend-confirmation.component.html',
  styleUrls: ['./instructor-resend-confirmation.component.css']
})
export class InstructorResendConfirmationComponent implements OnInit {
  
  emailId: any;

  constructor(private shoppingService: ShoppingService, public activeModal: NgbActiveModal  ) { }

  ngOnInit() {
    this.shoppingService.ResendConfirmationEmail(this.emailId).subscribe((response: any) => {
      if (response) {
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shoppingcart/modals/instructor-resend-confirmation/instructor-resend-confirmation.component.ts